<template>
  <div>
    <!-- RoundTrip Option -->
    <div class="search-page-tab d-flex justify-space-between align-center">
      <div class="d-flex">
        <!-- <div :class="['tab-opt', {active:!isReturning && otherTabs.indexOf(widgetTab) === -1}]" @click="isReturning = false">Ride</div>
        <div :class="['tab-opt', {active:isReturning && otherTabs.indexOf(widgetTab) === -1 }]" @click="isReturning = true">Flight</div> -->
        <div :class="['tab-opt', {active:xTab === 'rideFlight' && widgetTab === 'd2d'}]" @click="changeTab('rideFlight')">Flight & Ride</div>
        <div :class="['tab-opt', {active:xTab === 'ride' && widgetTab === 'd2d'}]" @click="changeTab('ride')">Ride</div>
        <div :class="['tab-opt', {active:xTab === 'flight' && widgetTab === 'd2d'}]" @click="changeTab('flight')">Flight</div>
        <!-- <div :class="['tab-opt', {active: widgetTab === 'things'}]" @click="activeThings">
          Things to-do
        </div> -->
        <div :class="['tab-opt', {active: widgetTab === 'sight-seeing'}]" @click="activeSightSeeing">
          Attractions
          <span class="to-new">NEW</span>
        </div>
        <div :class="['tab-opt', {active: widgetTab === 'hotel'}]" @click="activehotel">
          Hotel
          <span class="to-new">NEW</span>
        </div>
      </div>
      <div class="d-flex sp-account">
        <div v-if="!user.token">
          <span>Already have an account?</span>
          <a @click="showGlobalLogin">Login</a>
        </div>
        <!-- <div v-if="!user.token">
          <span>Don't have an account?</span>
          <a @click="showGlobalSignup">Sign Up</a>
        </div> -->
        <div class="welcome-txt" v-else>
          <div>
            Welcome, 
            <b @click="showUserInfo" class="user-x">{{ user.firstName }}</b>!
          </div>
          <a @click="getList" class="mng-flights">
            <i class="fas fa-plane fa-fw"></i>
            My Trips
          </a>
          <a @click="logout" class="logout">Logout</a>
        </div>
      </div>
    </div>

    <!-- Search FIELDS -->
    <div class="search-page-fields dx-flex align-start" v-show="otherTabs.indexOf(widgetTab) === -1">
      <div :class="['field-group full-width add-limit', {active:highlight.active==='pickup'}]">
        <location-input :value="pickup" :extra="pickupExtra" ref="pickup"
          :disabled="quickQuoteCheck" :error="validation.pickup" leg="leg1"
          @change="locationNewValue" @submit="triggerClickSubmit"
          @nextFocus="nextHighlight" @clickFocus="highlight.active = 'pickup'"
        ></location-input>
      </div>

      <div class="reverse-loc-box d-flex align-center justify-center">
        <i :class="['fas fa-exchange-alt reverse-loc', {disabled:quickQuoteCheck}]" @click="reverseLoc"></i>
      </div>

      <div :class="['field-group full-width add-limit', {active:highlight.active==='dropoff'}]">
        <location-input :value="dropoff" :extra="dropoffExtra" ref="dropoff"
          :disabled="quickQuoteCheck" :error="validation.dropoff" leg="leg1"
          @change="locationNewValue" @submit="triggerClickSubmit" 
          @nextFocus="nextHighlight" @clickFocus="highlight.active = 'dropoff'"
        ></location-input>
      </div>

      <div :class="['field-group', {active:highlight.active==='cabin'}]" v-if="xTab != 'ride'">
        <select v-model="minCabin" class="min-cabin">
          <option v-for="(cabin, i) in booking.cabinList" :key="i" :value="cabin">{{ cabinLabel(cabin) }}</option>
        </select>

        <label class="for-someone" v-if="user.token">
          <input type="checkbox" v-model="forSomeoneElse" />
          <span>Book for someone else.</span>
        </label>
      </div>

      <a href="#/d2dservice" @click="locationSubmit($event)" ref="quoteBtn"
        :class="['lr-btn', {'disabled':quickQuoteCheck, active:highlight.active==='search'}]"
      >
        Search
      </a>
    </div>

    <!-- Things to-do FORM -->
    <!-- <things v-if="widgetTab === 'things'" /> -->

    <!-- Sight Seeing FORM -->
    <sight-seeing v-if="widgetTab === 'sight-seeing'" />

    <!-- Sight Seeing FORM -->
    <hotel v-if="widgetTab === 'hotel'" />

    <!-- Search Notes -->
    <div class="search-page-notes">
      <div>Enter your pickup address (like your home or office) and destination — we'll take care of the rest.</div>
      <i class="fas fa-check-square"></i>
      We'll find your best flights + private car transfers in one search.
    </div>

    <departure-modal @newDate="newDate"></departure-modal>
    <travellers-modal @submit="submit($event, true)"></travellers-modal>
    <ground-widget ref="groundWidget" v-show="false"></ground-widget>
  </div>
</template>

<script>
/* global CONFIG */
const request = require('browser-request')
// const cookie = require('vue-cookie')

import WidgetSession from '@/modules/session'
import moment from 'moment'
import LocationInput from './LocationInput'
import DepartureModal from './DateTimePicker'
import TravellersModal from './TravellersModal'
import GroundWidget from './Ground'
// import Things from './Things'
import SightSeeing from './SightSeeing'
import hotel from './hotel'
import booking from '@/modules/api/booking'
import trackError from '@/modules/api/track-error'
import currencyCountry from '@/data/currency-country.js'
import airlines from '@/data/airlines.js'
import ApiQuote from '@/modules/api/quote'

export default {
  name: 'search-page',
  components: { LocationInput, DepartureModal, TravellersModal, GroundWidget, /* Things, */SightSeeing, hotel },
  data () {
    return {
      pickup: '',
      dropoff: '',
      pickupText: '',
      dropoffText: '',
      highlight: {
        active: 'pickup',
        delay: ''
      },
      validation: {
        pickup: '',
        dropoff: ''
      },
      quickQuoteCheck: false,
      flightEnable: false,
      d2dQueue: [],
      d2dValidation: {
        date: ''
      },
      flightQuoteError: {
        leg1: 0,
        leg2: 0
      },
      groundQuoteError: {
        pickup: '',
        dropoff: ''
      },
      tmpSearchedLoc: [],
      session: '',
      skipDate: false,
      internationalCheckList: [],
      otherTabs: ['sight-seeing', 'hotel'],
      xTab: 'rideFlight'
    }
  },
  computed: {
    brandId () { return this.$store.state.brandId },
    user () { return this.$store.state.user },
    booking () { return this.$store.state.booking },
    airlines () { return this.booking.airlines },
    filters () { return this.booking.filters },
    locations () { return this.booking.locations },
    isReturning: {
      get () { return this.filters.departure.isReturning },
      set (x) {
        let widgetType = this.locations.isAirportPickup && this.locations.isAirportDropoff ? 'flight' : 'd2d'
        this.$store.commit('other/setOtherData', {widgetTab: widgetType})
        this.$store.commit('booking/setDepartureData', {isReturning: x})
      }
    },
    hideGround () { return this.booking.hideGround },
    pickupExtra () {
      // let ph = !this.forSomeoneElse ? 'Enter your pickup location' : 'Enter your guest pickup location'
      let ph = 'Enter your Pickup Address i.e. Home, Airport etc'
      return {
        field: 'pickup',
        placeholder: ph,
        type: 'd2d'
      }
    },
    dropoffExtra () {
      // let ph = !this.forSomeoneElse ? 'Enter your dropoff location' : 'Enter your guest dropoff location'
      let ph = 'Enter your Destination Address i.e. Home, Airport etc'
      return {
        field: 'dropoff',
        placeholder: ph,
        error: this.validation.dropoff,
        type: 'd2d'
      }
    },
    other () { return this.$store.state.other },
    currencyStore () { return this.other.currency },
    widgetTab () { return this.other.widgetTab },
    _pickup () { return this.locations.pickup.title },
    _dropoff () { return this.locations.dropoff.title },
    apiType () { return this.booking.apiType },
    minCabin: {
      get () { return this.booking.minCabin },
      set (x) { this.$store.commit('booking/setOthersData', {minCabin: x}) }
    },
    forSomeoneElse: {
      get () { return this.filters.travellers.forSomeoneElse },
      set (x) { this.$store.commit('booking/setTravellersData', {forSomeoneElse: x}) }
    },
    logoutStore () { return this.$store.state.global.logout },
    settings () { return this.booking.settings },
    lyftStore () { return this.$store.state.lyft }
  },
  methods: {
    showGlobalLogin () {
      this.$store.commit('global/setAuthData', {show: true})

      if (window.gtag) { // eslint-disable-line
        gtag('event', 'Flight Booking - Login') // eslint-disable-line
      }
    },
    showGlobalSignup () {
      // this.$store.commit('global/setAuthData', {showSignup: true})
      this.$store.commit('global/setAuthData', {signupSelect: true})

      if (window.gtag) { // eslint-disable-line
        gtag('event', 'Flight Booking - Signup') // eslint-disable-line
      }
    },
    showUserInfo () {
      this.$store.commit('global/setUserInfoData', {show: true})
    },
    logout () {
      this.$store.commit('global/setLogoutData', {show: true})
      // let self = this
      // self.session.destroy()
      // self.$store.commit('user/reset')
      // cookie.delete('userToken')
      // self.$store.commit('cards/setCardData', {
      //   lastUserID: '',
      //   list: []
      // })
      // self.$store.commit('setCredits', 0)
      // self.forSomeoneElse = false
      // self.$store.commit('global/setLoaderData', {show: true})
      // setTimeout(function () {
      //   self.$store.commit('global/setLoaderData', {show: false})
      // }, 500)
    },
    getList () {
      let self = this
      if (self.lyftStore.services.length) {
        self.getFlights()
        return
      }

      self.$sdk.get(self, '/service/lyft', {}, res => {
        if (!res.error) self.$store.commit('lyft/setLyftData', {services: res})
        self.getFlights()
      }, '2.0')
    },
    getFlights () {
      let self = this
      // self.showLoggedInOptions = false
      self.$store.commit('global/setLoaderData', {show: true})
      self.$sdk.post2(`${CONFIG.d2dGateway}/d2d/get`, {
        token: self.user.token,
        order: 'pickupTime',
        status: 'upcoming',
        desc: false,
        pageNum: 1,
        pageSize: 50,
        raw: true
      }, r => {
        if (r.error) {
          // self.$store.commit('global/setLoaderData', {show: false})
          // self.$store.commit('global/setAlertData', {
          //   show: true,
          //   message: r.error.message
          // })
          self.getGroundBookings()
          return
        }
        if (!r.list.length) {
          // self.$store.commit('global/setAlertData', {
          //   show: true,
          //   message: 'No booked flights as of yet.'
          // })
          self.$store.commit('flights/setFlightData', {list: []})
          // setTimeout(function () {
          //   self.$store.commit('global/setLoaderData', {show: false})
          //   self.$store.commit('flights/setFlightTrackData', {enable: false})
          //   document.body.classList.add('widget-full', 'd2d-mode')
          //   self.$router.push('my-flights')
          // }, 250)
          self.getGroundBookings()
          return
        }
        let flights = []
        r.list.forEach(f => {
          if (f.roundTripId) {
            let index = flights.findIndex(x => x.id === f.roundTripId)
            if (index > -1) {
              flights[index].roundTripData = self.buildFlightListData(f)
              return
            }
          }
          flights.push(self.buildFlightListData(f))
        })
        self.$store.commit('flights/setFlightData', {list: flights})
        self.getGroundBookings()
        // setTimeout(function () {
        //   self.$store.commit('global/setLoaderData', {show: false})
        //   self.$store.commit('flights/setFlightTrackData', {enable: false})
        //   document.body.classList.add('widget-full', 'd2d-mode')
        //   self.$router.push('my-flights')
        // }, 250)
      })
    },
    buildFlightListData (f) {
      let logo = ''
      if (f.commitData && f.commitData.CommitBooking && f.commitData.CommitBooking.BookingDetails.JourneyList.FlightDetails.Details.length) {
        logo = f.commitData.CommitBooking.BookingDetails.JourneyList.FlightDetails.Details[0][0].DisplayOperatorCode
        let tmp = airlines.find(x => x.code === logo)
        if (tmp) logo = tmp.logo
      }
      let isRefundable = false
      if (f.priceData) isRefundable = f.priceData.UpdateFareQuote.FareQuoteDetails.JourneyList.Attr.IsRefundable
      return {
        id: f.id,
        bookingId: f.bookingId,
        pnr: f.pnr,
        origin: {
          code: f.originAirportCode,
          name: f.originAirportName,
          date: moment(f.originDateTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA')
        },
        destination: {
          code: f.destAirportCode,
          name: f.destAirportName,
          date: moment(f.destDateTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA')
        },
        status: f.status,
        // isRoundTrip: f.roundTripId ? (f.id < f.roundTripId ? 'round-trip' : '') : '',
        dateSort: parseInt(moment(f.originDateTime, 'YYYY-MM-DD HH:mm').format('x')),
        logo: logo,
        isRefundable: isRefundable
      }
    },
    getGroundBookings () {
      let self = this
      self.$sdk.get(self, '/me/reservations/upcoming', {
        token: self.user.token,
        brandId: self.brandId
      }, r => {
        if (!r.error) {
          let list = []
          r.list.forEach(rsvp => {
            let rsvpData = {
              id: rsvp.ID,
              service: rsvp.serviceType,
              pickup: rsvp.pickup,
              dropoff: rsvp.dropoff,
              pickupDate: moment(rsvp.pickupDate, 'YYYY-MM-DD HH:mm').format('DD MMM YYYY'),
              dateSort: parseInt(moment(rsvp.pickupDate, 'YYYY-MM-DD HH:mm').format('x')),
              logo: rsvp.serviceType.image,
              isGround: true,
              isAsap: rsvp.isAsap
            }
            if (rsvp.lyft) {
              rsvpData.service.name = rsvp.lyft.custom_name
              rsvpData.logo = rsvp.lyft.custom_image
            }
            list.push(rsvpData)
          })
          self.$store.commit('flights/addFlightList', list)
          self.$store.commit('flights/sortList')
        } else {
          self.$store.commit('global/setLoaderData', {show: false})
          self.$store.commit('global/setAlertData', {
            show: true,
            message: 'No trips as of yet.'
          })
          return
        }

        setTimeout(function () {
          self.$store.commit('global/setLoaderData', {show: false})
          self.$store.commit('flights/setFlightTrackData', {enable: false})
          document.body.classList.add('widget-full', 'd2d-mode')
          self.$router.push('my-flights')
        }, 250)
      })
    },
    locationNewValue (value) {
      let self = this
      if (value.fromMap && !value.keyInput.trim()) return

      if (value.field === 'pickup') {
        self.pickupText = value.keyInput
        // this.$emit('pickupChange')
        if (value.keyInput.trim() === '') {
          self.$store.commit('booking/setLocationsData', {pickup: {}})
        } else {
          if (!value.blurStop) {
            this.validation.pickup = ''
            this.$refs.dropoff.focus()
          }
        }
      } else {
        self.dropoffText = value.keyInput
        if (value.keyInput.trim() === '') {
          self.$store.commit('booking/setLocationsData', {dropoff: {}})
        } else {
          this.validation.dropoff = ''
        }
      }

      if (value.keyInput && value.check) {
        let tmpObj = {}
        tmpObj[value.field] = value.isAirport
        self.$store.commit('booking/setHideGround', tmpObj)

        let tmpIsAirport = {}
        tmpIsAirport[`${value.field === 'pickup' ? 'isAirportPickup' : 'isAirportDropoff'}`] = value.isAirport
        self.$store.commit('booking/setLocationsData', tmpIsAirport)

        if (self.pickupText && self.dropoffText) {
          setTimeout(() => {
            self.$nextTick().then(() => {
              self.$forceUpdate()
              self.checkGroundQuote('check', {})
            })
          }, 250)
        }
      }
    },
    triggerClickSubmit () {
      if (this.$refs.quoteBtn) this.$refs.quoteBtn.click()
    },
    nextHighlight () {
      if (!this.pickupText && !this.validation.pickup) this.highlight.active = 'pickup'
      else if ((this.highlight.active === 'pickup' || !this.dropoffText) && !this.validation.dropoff) this.highlight.active = 'dropoff'
      else if (this.highlight.active === 'dropoff') this.highlight.active = 'date'
      else if (this.highlight.active === 'date') this.highlight.active = 'pax'
      else if (this.highlight.active === 'pax') this.highlight.active = 'search'
    },
    reverseLoc () {
      // if (this.quickQuoteCheck) return
      let pickup = Object.assign({}, this.locations.pickup)
      let dropoff = Object.assign({}, this.locations.dropoff)

      this.dropoffText = pickup.title
      this.pickupText = dropoff.title
      this.dropoff = pickup.title
      this.pickup = dropoff.title
      this.$store.commit('booking/setLocationsData', {
        pickup: dropoff,
        dropoff: pickup
      })
      this.$store.commit('airports/sortList', { lat: dropoff.lat, lng: dropoff.lng })
      // this.$emit('pickupChange')
    },
    openDeparturePicker () {
      this.$store.commit('booking/setDepartureData', {show: true})
    },
    newDate () {
      this.openTravellersModal()
      // if (this.other.widgetTab === 'd2d' && this.locations.pickup.title && this.locations.dropoff.title) {
      //   // if (this.$refs.d2dWidget) this.$refs.d2dWidget.submit()
      //   this.openTravellersModal()
      // }
      // if (this.other.widgetTab === 'flight' && this.locations.flight.pickup.title && this.locations.flight.dropoff.title) {
      //   // if (this.$refs.flightWidget) this.$refs.flightWidget.submit()
      //   this.openTravellersModal()
      // }

      if (window.gtag) { // eslint-disable-line
        gtag( // eslint-disable-line
          'event',
          'Flight Booking - Date',
          {value: this.departureDate}
        )
      }
    },
    openTravellersModal () {
      this.$store.commit('booking/setTravellersData', {show: true})
    },
    locationSubmit (event = null) {
      if (event) event.preventDefault()
      let self = this
      self.validation.pickup = ''
      self.validation.dropoff = ''
      let hasError = false
      if (self.pickupText.trim() === '') {
        hasError = true
        self.validation.pickup = self.$t('common.fieldEmpty')
      } else if ((typeof self.locations.pickup === 'object' && !Object.keys(self.locations.pickup).length) || !self.locations.pickup) {
        hasError = true
        self.validation.pickup = 'Please select location'
      }
      if (self.dropoffText.trim() === '') {
        hasError = true
        self.validation.dropoff = self.$t('common.fieldEmpty')
      } else if ((typeof self.locations.dropoff === 'object' && !Object.keys(self.locations.dropoff).length) || !self.locations.dropoff) {
        hasError = true
        self.validation.dropoff = 'Please select location'
      }
      // if (!self.filters.departure.date) {
      //   hasError = true
      //   self.d2dValidation.date = self.$t('common.fieldEmpty')
      // }

      if (!!self.validation.pickup && this.highlight.active === 'pickup') this.highlight.active = ''
      if (!!self.validation.dropoff && this.highlight.active === 'dropoff') this.highlight.active = ''

      if (hasError) return

      // this.openDeparturePicker()
      this.checkGroundQuote('check', {})
    },
    submit (event = null, skipDate = false) {
      this.skipDate = skipDate
      if (event) event.preventDefault()
      // if (this.quickQuoteCheck) return
      let self = this

      if (window.gtag) { // eslint-disable-line
        gtag('event', 'Flight Booking - Search') // eslint-disable-line
      }

      self.$store.commit('other/setOtherData', {
        appLoader: true,
        appLoaderMsg: ''
      })

      // Reset Quote Errors
      self.flightQuoteError = {leg1: 0, leg2: 0}
      self.groundQuoteError = {pickup: '', dropoff: ''}

      let widgetType = self.locations.isAirportPickup && self.locations.isAirportDropoff ? 'flight' : 'd2d'
      self.$store.commit('other/setOtherData', {widgetTab: widgetType})

      self.d2dQueue = []
      // 'checkPickupDropoffDistance'
      self.d2dQueue = ['getAirports', 'pickupNearestAirport', 'dropoffNearestAirport', 'checkInternationalAirport']
      if (!localStorage.getItem('firstVisitData') && !self.user.token && self.settings.requirePhone) self.d2dQueue.push('getMobile')
      else self.d2dQueue.push('getFlight')
      self.$store.commit('booking/setSelectedData', {leg1: {}, leg2: {}})
      self.d2dProcess()
    },
    d2dProcess () {
      let self = this
      if (!self.d2dQueue.length) return
      if (self.d2dQueue[0] === 'checkPickupDropoffDistance') {
        self.$store.commit('other/setOtherData', {appLoaderMsg: 'Checking Locations...'})
        self.checkGroundQuote('check', {})
        return
      }
      if (self.d2dQueue[0] === 'getAirports') {
        self.$store.commit('other/setOtherData', {appLoaderMsg: 'Getting airport data...'})
        self.getAirportList()
        return
      }
      if (self.d2dQueue[0] === 'pickupNearestAirport') {
        self.$store.commit('other/setOtherData', {appLoaderMsg: 'Searching for nearby Airport...'})
        self.checkNearestAirport('pickup')
        return
      }
      if (self.d2dQueue[0] === 'dropoffNearestAirport') {
        self.$store.commit('other/setOtherData', {appLoaderMsg: 'Searching for nearby Airport...'})
        self.checkNearestAirport('dropoff')
        return
      }
      if (self.d2dQueue[0] === 'checkInternationalAirport') {
        let pickupAirports = []
        self.booking.nearByAirports.pickup.forEach(x => { pickupAirports.push(x.airport.code) })
        let dropoffpAirports = []
        self.booking.nearByAirports.dropoff.forEach(x => { dropoffpAirports.push(x.airport.code) })
        self.internationalCheckList = [
          {
            location: self.locations.pickup.title,
            airports: pickupAirports
          },
          {
            location: self.locations.dropoff.title,
            airports: dropoffpAirports
          }
        ]
        self.checkInternationalAirport()
        return
      }
      if (self.d2dQueue[0] === 'getFlight') {
        self.$store.commit('other/setOtherData', {
          appLoaderMsg: 'Don’t close now—your perfect deal is loading! This only takes up to a minute.',
          useLoadingMsg: true
        })

        // let tmp = {loading: [], selectedCabin: 'Economy'}
        let tmp = {loading: [], selectedCabin: 'API2'}
        self.$store.commit('booking/setAirlinesLegData', {leg: 'leg1', fields: tmp})

        // let leg1 = [...self.booking.cabinList]
        // leg1.forEach(cabin => {
        //   self.getFlightQuote(cabin, 'leg1')
        //   if (self.isReturning) self.getFlightQuote(cabin, 'leg2')
        // })
        // self.$store.commit('booking/setOthersData', {apiType: 'API1'})

        let pickup = self.locations.pickup
        let dropoff = self.locations.dropoff
        let isIndia = pickup.country === 'IND' && dropoff.country === 'IND'
        self.$store.commit('booking/setSettingsData', {customFlight: isIndia})

        let cabins = [...self.booking.cabinList]
        cabins = cabins.splice(cabins.indexOf(self.minCabin))
        self.getFlightQuote(cabins, 'leg1')
        if (self.isReturning && self.settings.customFlight) {
          self.$store.commit('booking/setAirlinesLegData', {leg: 'leg2', fields: {selectedCabin: 'API2'}})
          self.getFlightQuote(cabins, 'leg2')
        }
        self.$store.commit('booking/setOthersData', {apiType: 'API2'})
      }
      if (self.d2dQueue[0] === 'getMobile') {
        self.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
        self.$store.commit('user/setFirstVisitData', {
          show: true,
          source: 'flight'
        })
      }
    },
    getAirportList () {
      let self = this
      if (self.booking.airports.length) {
        self.d2dQueue.shift()
        self.d2dProcess()
        return
      }

      self.$sdk.get(self, '/airport', {}, r => {
        let airports = []
        if (r.list) {
          r.list.forEach(data => {
            airports.push({
              name: data.name,
              code: data.code,
              address1: data.addressLine1,
              address2: data.addressLine2,
              city: data.city,
              state: data.state,
              zip: data.zipCode,
              country: data.country,
              lat: data.lat,
              lng: data.lng
            })
          })
        }
        self.$store.commit('booking/setAirportData', {airports: airports})
        setTimeout(function () {
          self.d2dQueue.shift()
          self.d2dProcess()
        }, 200)
      }, '2.0')
    },
    checkNearestAirport (type) {
      let self = this
      let loc = self.locations[type]
      let coord1 = {
        lat: loc.lat,
        lng: loc.lng
      }
      let nearest = {
        airport: {},
        distance: ''
      }
      let tmpList = []
      self.booking.airports.forEach((x, i) => {
        let currentDistance = self.getDistance(coord1, {lat: x.lat, lng: x.lng})
        if (!nearest.distance) {
          nearest.airport = self.booking.airports[i]
          nearest.distance = currentDistance
        } else if (currentDistance < nearest.distance) {
          nearest.airport = self.booking.airports[i]
          nearest.distance = currentDistance
        }
        if (currentDistance <= self.settings.nearByAirportMilesLimit) {
          tmpList.push({
            airport: self.booking.airports[i],
            distance: currentDistance
          })
        }
      })

      tmpList.sort((a, b) => {
        return a.distance - b.distance
      })
      if (tmpList.length > 1 && tmpList[0].distance < tmpList[1].distance) nearest.airport = tmpList[0].airport
      let codeIndex = tmpList.findIndex(x => x.code === loc.code)
      if (codeIndex !== -1) nearest.airport = tmpList[0].airport

      let tmp = {}
      tmp[type] = tmpList
      self.$store.commit('booking/setNearyByAirports', tmp)
      if (!tmpList.length) {
        trackError.track(self, {
          type: 'no_nearby_airport',
          data: {
            main_pickup: self.locations.pickup,
            main_dropoff: self.locations.dropoff,
            request: '',
            response: '',
            target: loc,
            D2DAirportDistanceLimitMiles: self.settings.nearByAirportMilesLimit
          }
        })
        self.d2dQueue = []
        self.$store.commit('global/setAlertData', {show: true, message: `Out of Coverage Area, We're working hard to cover your pickup/drop-off location soon.`})
        self.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
        return
      }

      let data = {}
      data[`${type}Airport`] = nearest.airport
      let reverseType = type === 'pickup' ? 'dropoff' : 'pickup'
      data[`${reverseType}AirportReturn`] = nearest.airport
      self.$store.commit('booking/setLocationsData', data)
      let tmpLoc = {}
      tmpLoc[type] = nearest.airport
      self.$store.commit('booking/setFlightLocationsData', tmpLoc)
      self.checkGroundQuote(type, data[`${type}Airport`])

      if (type === 'pickup' && CONFIG.featureToggle.quoteReroute) {
        // Set Locations
        self.$store.commit('reservation/setPickup', {leg: 'leg1', value: self.locations.pickup})
        self.$store.commit('reservation/setDropoff', {leg: 'leg1', value: nearest.airport})
        self.$store.commit('reservation/setIsAirportPickup', {leg: 'leg2', value: true})
        // Set Date
        self.$store.commit('reservation/setIsAsap', {leg: 'leg1', value: false})
        let timeNow = moment()
        let div5 = timeNow.minutes() % 5
        timeNow = timeNow.subtract(div5, 'minutes')
        self.$store.commit('reservation/setPickupDate', {leg: 'leg1', value: `${self.filters.departure.date} ${timeNow.format('hh:mmA')}`})
        self.$store.commit('serviceSelection/setForPickupDate', false)
      }
    },
    checkGroundQuote (type, airport) {
      let self = this

      if (self.other.widgetTab === 'flight' && type !== 'check') {
        self.d2dQueue.shift()
        self.d2dProcess()
        return
      }
      // if (self.quickQuoteCheck) return
      self.quickQuoteCheck = true

      let pickupDate = moment(self.filters.departure.date, 'MM/DD/YYYY').format('YYYY-MM-DD')
      let quoteData = {
        pickupDate: pickupDate,
        leg: 'leg1',
        brandId: self.$store.state.brandId,
        order: 'priority',
        asap: false,
        d2dflight: 1
      }
      if (self.isReturning) this.$store.commit('reservation/setIsAsap', { leg: 'leg1', value: false })

      if (quoteData.pickupDate === 'Invalid date') quoteData.pickupDate = moment().format('YYYY-MM-DD')
      let origin = type === 'pickup' ? self.locations.pickup : airport
      let destination = type === 'pickup' ? airport : self.locations.dropoff
      if (type === 'check') {
        origin = self.locations.pickup
        destination = self.locations.dropoff
        if (origin.lat === destination.lat && origin.lng === destination.lng) {
          self.quickQuoteCheck = false
          self.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
          self.$store.commit('global/setAlertData', {show: true, message: 'Please select a different location.'})
          return
        }
      }
      quoteData.pickup = {
        lat: origin.lat,
        lng: origin.lng,
        state: origin.state,
        country: origin.country
      }
      quoteData.dropoff = {
        lat: destination.lat,
        lng: destination.lng,
        state: destination.state,
        country: destination.country
      }
      let timeNow = moment()
      if (origin.country === 'IND') {
        quoteData.pickup.text = origin.title || origin.name
        quoteData.dropoff.text = destination.title || destination.name
        quoteData.pickupTimestamp = moment(self.filters.departure.date, 'MM/DD/YYYY').format('X')
        quoteData.dynamicTime = false
        quoteData.tripType = 1
      }

      // let searchIndex = self.tmpSearchedLoc.findIndex(x => x.pickup.lat === quoteData.pickup.lat && x.pickup.lng === quoteData.pickup.lng && x.dropoff.lat === quoteData.dropoff.lat && x.dropoff.lng === quoteData.dropoff.lng)
      // if (searchIndex > -1) {
      //   self.quickQuoteCheck = false
      //   if (!self.skipDate) self.openDeparturePicker()
      //   // else {
      //   self.d2dQueue.shift()
      //   self.d2dProcess()
      //   // }
      //   self.skipDate = false
      //   return
      // }
      self.skipDate = false

      let usa = ['us', 'usa', 'united states', 'united states of america']
      let canada = ['can', 'ca', 'canada']
      let ca = ['ca', 'california']
      if (type !== 'check' &&
      (
        (quoteData[type].country && usa.indexOf(quoteData[type].country.toLowerCase()) > -1 && quoteData[type].state && ca.indexOf(quoteData[type].state.toLowerCase()) === -1) ||
        (quoteData[type].country && canada.indexOf(quoteData[type].country.toLowerCase()) > -1)
      )
    ) {
        self.lyftQuoteCheck(type, airport, quoteData)
        return
      }

      self.$sdk.post(self, '/quotation', quoteData, r => {
        self.tmpSearchedLoc.push({
          pickup: quoteData.pickup,
          dropoff: quoteData.dropoff
        })

        self.sendQuoteTime(timeNow, moment(), r.quoteId, quoteData)
        self.quickQuoteCheck = false
        if (r.error && type !== 'check') {
          if (
            (quoteData[type].country && usa.indexOf(quoteData[type].country.toLowerCase()) > -1) ||
            (quoteData[type].country && canada.indexOf(quoteData[type].country.toLowerCase()) > -1)
          ) {
            self.lyftQuoteCheck(type, airport, quoteData)
            return
          }
          let msg = 'Out of Coverage Area, We\'re working hard to cover your pickup/drop-off location soon.'
          if (CONFIG.featureToggle.quoteReroute) {
            self.groundQuoteError[type] = msg
            self.d2dQueue.shift()
            self.d2dProcess()
            return
          }
          self.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
          self.$store.commit('global/setAlertData', {show: true, message: msg})
          trackError.track(self, {
            type: 'ground_booking',
            data: {
              main_pickup: self.locations.pickup,
              main_dropoff: self.locations.dropoff,
              request: {
                route: '/quotation',
                payload: quoteData
              },
              response: r
            }
          })
          return
        }
        if (r.error && type === 'check') {
          self.flightEnable = true
          self.openDeparturePicker()
          return
        }
        if (!r.error) {
          if (type === 'check') {
            let lyftEnabled = false
            if (r.geofences) {
              lyftEnabled = true
              if ((quoteData.pickup.country && usa.indexOf(quoteData.pickup.country.toLowerCase()) === -1) ||
                ca.indexOf(quoteData.pickup.state.toLowerCase() > -1) && r.geofences.servicearea.name.includes('LAX')
              ) { lyftEnabled = false }
              if (quoteData.pickup.country && canada.indexOf(quoteData.pickup.country.toLowerCase()) === -1) lyftEnabled = true
              self.$store.commit('reservation/setLyftData', {enabled: lyftEnabled})
            }

            if (r.route.distance <= self.settings.forceGroundMiles) {
              self.$store.commit('global/setLoaderData', {show: true})
              self.flightEnable = false
              self.$store.commit('reservation/setPickup', {leg: 'leg1', value: self.locations.pickup})
              self.$store.commit('reservation/setDropoff', {leg: 'leg1', value: self.locations.dropoff})
              self.$store.commit('reservation/setIsAirportPickup', {leg: 'leg1', value: false})
              self.$store.commit('reservation/setIsAirportDropoff', {leg: 'leg1', value: false})
              self.$store.commit('reservation/setIsAsap', { leg: 'leg1', value: false })
              let timeNow = moment()
              let div5 = timeNow.minutes() % 5
              timeNow = timeNow.subtract(div5, 'minutes')
              let date = self.filters.departure.date || moment().format('MM/DD/YYYY')
              self.$store.commit('reservation/setPickupDate', { leg: 'leg1', value: `${date} ${timeNow.format('hh:mmA')}` })
              self.$store.commit('serviceSelection/setForPickupDate', false)
              let roundttrip = self.filters.departure.isReturning
              self.$store.commit('reservation/setIsRoundtrip', roundttrip)
              if (roundttrip) {
                self.$store.commit('reservation/setRtPricing', true)
                self.$store.commit('reservation/setIsAirportPickup', {leg: 'leg2', value: false})
                self.$store.commit('reservation/setIsAirportDropoff', {leg: 'leg2', value: false})
                let date2 = self.filters.departure.return || moment().add(1, 'days').format('MM/DD/YYYY')
                self.$store.commit('reservation/setPickupDate', { leg: 'leg2', value: `${date2} ${timeNow.format('hh:mmA')}` })
              }
              // self.$emit('forceGround')
              // if (self.$refs.groundWidget) {
              //   self.$refs.groundWidget.forceGround()
              // }
              if (lyftEnabled) {
                self.$store.commit('reservation/setIsRoundtrip', false)
                self.getLyftQuote('leg1')
                return
              }
              self.prepForceGround()
              return
            }
            self.quickQuoteCheck = false
            // self.flightEnable = true
            self.openDeparturePicker()
            return
          }

          if (type !== 'check' &&
            quoteData[type].country && usa.indexOf(quoteData[type].country.toLowerCase()) > -1 &&
            (ca.indexOf(quoteData[type].state.toLowerCase()) === -1 ||
            (ca.indexOf(quoteData[type].state.toLowerCase()) > -1 && !r.geofences.servicearea.name.includes('LAX')))
          ) {
            self.lyftQuoteCheck(type, airport, quoteData)
            return
          }

          if ((!r.services.length && !r.mtech) || (r.mtech && !r.mtech.services.length)) {
            let msg = self.$t('searchForm.noAvailableService')
            if (CONFIG.featureToggle.quoteReroute) {
              self.groundQuoteError[type] = msg
              self.d2dQueue.shift()
              self.d2dProcess()
              return
            }
            self.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
            self.$store.commit('global/setAlertData', {show: true, message: msg})
            trackError.track(self, {
              type: 'ground_booking',
              data: {
                main_pickup: self.locations.pickup,
                main_dropoff: self.locations.dropoff,
                request: {
                  route: '/quotation',
                  payload: quoteData
                },
                response: r
              }
            })
            return
          }
        }
        self.d2dQueue.shift()
        self.d2dProcess()
      }, '2.0')
    },
    lyftQuoteCheck (type, airport, param) {
      let self = this
      let newParam = {
        brandId: param.brandId,
        pickup: param.pickup,
        dropoff: param.dropoff,
        pickupTime: moment(param.pickupDate, 'YYYY-MM-DD').format('X'),
        leg: param.leg
      }

      self.$sdk.post(self, '/quotation/lyft/future', newParam, res => {
        self.quickQuoteCheck = false
        if (res.lyft) {
          let hasService = false
          res.lyft.forEach(x => {
            if (x.can_request_ride) hasService = true
          })
          if (!hasService) res.lyft = []
        }
        if (!res.lyft.length) {
          let msg = self.$t('searchForm.noAvailableService')
          if (CONFIG.featureToggle.quoteReroute) {
            self.groundQuoteError[type] = msg
            self.d2dQueue.shift()
            self.d2dProcess()
            return
          }
          self.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
          self.$store.commit('global/setAlertData', {show: true, message: msg})
          trackError.track(self, {
            type: 'ground_booking',
            data: {
              main_pickup: self.locations.pickup,
              main_dropoff: self.locations.dropoff,
              request: {
                route: '/quotation/lyft/future',
                payload: newParam
              },
              response: res
            }
          })
          return
        }
        self.d2dQueue.shift()
        self.d2dProcess()
      }, '2.0')
    },
    getDistance (coord1, coord2) {
      let toRad = value => value * Math.PI / 180
      let R = 6371
      let latD = toRad(coord2.lat - coord1.lat)
      let longD = toRad(coord2.lng - coord1.lng)
      let a = Math.sin(latD / 2) * Math.sin(latD / 2) +
        Math.cos(toRad(coord1.lat)) * Math.cos(toRad(coord2.lat)) *
        Math.sin(longD / 2) * Math.sin(longD / 2)
      let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
      let distance = R * c
      return distance / 1.609344
    },
    checkInternationalAirport () {
      let self = this

      if (!self.internationalCheckList.length) {
        self.d2dQueue.shift()
        self.d2dProcess()
        return
      }

      self.$sdk.post2(`${CONFIG.d2dAPI}/api/airports`, {
        code: self.internationalCheckList[0].airports
      }, r => {
        if (r.success) {
          // let tmp = {}
          // tmp[self.internationalCheckList[0].location] = r.airports[0]
          self.$store.commit('booking/setInternationalAirport', {
            location: self.internationalCheckList[0].location,
            code: r.airports[0]
            // field: 'international',
            // val: tmp
          })
        }
        self.internationalCheckList.shift()
        self.checkInternationalAirport()
      })
    },
    getFlightQuote (cabin, leg) {
      let self = this
      let tmpCabin = (typeof cabin === 'object') ? 'API2' : cabin

      if (self.booking.airlines[leg].loading.indexOf(tmpCabin) > -1) return
      self.$store.commit('booking/toggleAirlinesLoading', {leg: leg, val: tmpCabin})

      // Reset Airlines Data - By Cabin
      booking.resetAirlineData(self, cabin, leg)

      let params = booking.flightParam(self, cabin, leg)
      self.$sdk.post2(`${CONFIG.d2dAPI}/flight`, params, r => {
        try {
          if (
            r === null || !Object.keys(r).length || r.code === 'ETIMEDOUT' ||
            (r.error && ['No flight data found for any cabin search type.', 'No flight data found in the response.'].indexOf(r.error) > -1) || r.success === false
          ) {
            self.flightQuoteError[leg] = 3
            // self.$store.commit('global/setAlertData', {show: true, message: 'No flights found for the specified location. Please try again later or verify the location entered.'})
            trackError.track(self, {
              type: 'flight_booking',
              data: {
                main_pickup: self.locations.pickup,
                main_dropoff: self.locations.dropoff,
                request: {
                  url: `${CONFIG.d2dAPI}/flight`,
                  payload: params
                },
                response: r
              }
            })
            self.$store.commit('booking/toggleAirlinesLoading', {leg: leg, val: tmpCabin})
            self.flightQuoteDone(cabin, leg)
            return
          }

          if (r.code === 'ERR_BAD_RESPONSE') {
            if (self.flightQuoteError[leg] < 2) self.flightQuoteError[leg] = 2
            // self.$store.commit('global/setAlertData', {show: true, message: `Oops! Something went wrong. Please try again later. `})
            trackError.track(self, {
              type: 'flight_booking',
              data: {
                main_pickup: self.locations.pickup,
                main_dropoff: self.locations.dropoff,
                request: {
                  url: `${CONFIG.d2dAPI}/flight`,
                  payload: params
                },
                response: r
              }
            })
            self.$store.commit('booking/toggleAirlinesLoading', {leg: leg, val: tmpCabin})
            self.flightQuoteDone(cabin, leg)
            return
          }

          let tmpStoredData = {leg: leg, fields: {}}
          tmpStoredData.fields[tmpCabin] = r
          self.$store.commit('global/setStoredFlightData', tmpStoredData)

          if (r.FlightDataList && r.FlightDataList.JourneyList && r.FlightDataList.JourneyList[0]) {
            let flightData = booking.buildFlightData(self, r, cabin, leg)

            // Save Flight List
            if (self.apiType === 'API1') {
              let tmpAirlineLegData = {leg: leg, fields: {}}
              tmpAirlineLegData.fields[tmpCabin] = flightData.flights
              self.$store.commit('booking/setAirlinesLegData', tmpAirlineLegData)
            } else if (Object.keys(flightData.cabinFlights).length) {
              for (var key in flightData.cabinFlights) {
                let tmpAirlineLegData = {leg: leg, fields: {}}
                tmpAirlineLegData.fields[key] = flightData.cabinFlights[key]
                self.$store.commit('booking/setAirlinesLegData', tmpAirlineLegData)
              }

              let tmpUniqueFlight = {leg: leg, fields: {API2: []}}
              for (var key2 in flightData.uniqueFlights) {
                tmpUniqueFlight.fields.API2.push(flightData.uniqueFlights[key2])
              }
              tmpUniqueFlight.fields.API2Raw = flightData.flights
              self.$store.commit('booking/setAirlinesLegData', tmpUniqueFlight)
            }

            // Save Airline Unique
            let tmpAirlineUnique = {}
            tmpAirlineUnique[tmpCabin] = flightData.airlinesUnique
            self.$store.commit('booking/setAirlinesUniqueLegData', {
              leg: leg,
              fields: tmpAirlineUnique
            })

            let tmpApplyFilter = {leg: leg, fields: {}}
            tmpApplyFilter.fields[tmpCabin] = true
            self.$store.commit('booking/setApplyFilter', tmpApplyFilter)

            self.setupPax()
            localStorage.removeItem('lastPickupLoc')
            localStorage.removeItem('lastDropoffLoc')
            localStorage.setItem('lastPickupLoc', JSON.stringify(self.locations.pickup))
            localStorage.setItem('lastDropoffLoc', JSON.stringify(self.locations.dropoff))
            if (Object.keys(self.locations.pickup).indexOf('isAirport') > -1) localStorage.setItem('fixLastPickupLoc', true)
            if (Object.keys(self.locations.dropoff).indexOf('isAirport') > -1) localStorage.setItem('fixLastDropoffLoc', true)
            self.$store.commit('reservation/setOtherData', {bookingType: 'flight'})
            self.$store.commit('booking/setOthersData', {activeLeg: 'leg1'})
            self.$store.commit('booking/toggleAirlinesLoading', {leg: leg, val: tmpCabin})
            setTimeout(() => {
              self.flightQuoteDone(cabin, leg)
            }, 500)
          }
        } catch (error) {
          if (self.flightQuoteError[leg] < 1) self.flightQuoteError[leg] = 1
          // self.$store.commit('global/setAlertData', {show: true, message: 'Something went wrong. Please adjust your search and try again.'})
          trackError.track(self, {
            type: 'flight_booking',
            data: {
              main_pickup: self.locations.pickup,
              main_dropoff: self.locations.dropoff,
              request: {
                url: `${CONFIG.d2dAPI}/flight`,
                payload: params
              },
              response: '',
              console_error: error
            }
          })
          self.$store.commit('booking/toggleAirlinesLoading', {leg: leg, val: tmpCabin})
          self.flightQuoteDone(cabin, leg)
        }
      })
    },
    setupPax () {
      let paxForm = { adult: [], children: [], infants: [] }
      let paxFields = {
        title: '',
        gender: '',
        firstName: '',
        middleName: '',
        lastName: '',
        suffix: '',
        mobile: '',
        email: '',
        bday: '',
        birthDay: '',
        birthMonth: '',
        birthYear: '',
        passport: '',
        address: '',
        city: '',
        zip: '',
        country: '',
        countryCode: ''
      }
      let defaultAdded = false
      for (let x = 0; x < this.filters.travellers.adult; x++) {
        let tmpObj = {}
        Object.keys(paxFields).forEach(f => {
          tmpObj[`${f}${x}`] = paxFields[f]
        })
        if (this.user.token && x === 0 && !defaultAdded) {
          if (this.user.title) tmpObj.title0 = this.user.title
          if (this.user.gender) {
            tmpObj.gender0 = this.user.gender
            if (this.user.gender === 'Male') tmpObj.gender0 = 1
            if (this.user.gender === 'Female') tmpObj.gender0 = 2
          }
          tmpObj.firstName0 = this.user.firstName
          tmpObj.lastName0 = this.user.lastName
          tmpObj.email0 = this.user.email
          tmpObj.mobile0 = this.user.phone.number
          tmpObj.countryCode0 = this.user.phone.code
          if (this.user.bday) {
            let dob = moment(this.user.bday, 'YYYY-MM-DD')
            tmpObj.birthDay0 = dob.format('DD')
            tmpObj.birthMonth0 = dob.format('MM')
            tmpObj.birthYear0 = dob.format('YYYY')
          }
          if (this.user.address) tmpObj.address0 = this.user.address
          if (this.user.city) tmpObj.city0 = this.user.city
          if (this.user.zip) tmpObj.zip0 = this.user.zip
          if (this.user.country) tmpObj.country0 = this.user.country
          if (this.user.passportNum) tmpObj.passport0 = this.user.passportNum
          defaultAdded = true
        }
        paxForm.adult.push(tmpObj)
      }
      for (let x = 0; x < this.filters.travellers.children; x++) {
        let tmpObj = {}
        Object.keys(paxFields).forEach(f => {
          tmpObj[`${f}${x}`] = paxFields[f]
        })
        paxForm.children.push(tmpObj)
      }
      for (let x = 0; x < this.filters.travellers.infants; x++) {
        let tmpObj = {}
        Object.keys(paxFields).forEach(f => {
          tmpObj[`${f}${x}`] = paxFields[f]
        })
        paxForm.infants.push(tmpObj)
      }
      this.$store.commit('booking/clearTravellerInfo')
      this.$store.commit('booking/addTravellerInfo', paxForm)
    },
    sendQuoteTime (start, end, quoteId, param) {
      let self = this
      let store = self.$store.state
      let duration = end.diff(start, 'milliseconds') / 1000
      self.$sdk.opt('/quotation/time', {
        token: store.user.token,
        brandId: store.brandId,
        quotationId: quoteId,
        responseTime: duration,
        deviceType: 'ww',
        data: JSON.stringify(param)
      }, res => {
        if (res.error) console.log('ERROR quotation time')
      })
    },
    flightQuoteDone (cabin, leg) {
      let self = this
      let airline = self.airlines[leg]
      let pass = {leg1: false, leg2: false}

      /*
        Check if selected cabin is done loading and not empty
        else check other airlines and change selected
      */

      if (airline.loading.indexOf(airline.selectedCabin) === -1) {
        pass[leg] = airline[airline.selectedCabin].length > 0
        if (!pass[leg]) {
          let cabins = self.apiType === 'API2' ? ['API2'] : [...self.booking.cabinList]
          let tmpLoading = [...airline.loading]
          let doneCabin = cabins.filter(x => { return tmpLoading.indexOf(x) === -1 })
          let hasChosen = false
          doneCabin.forEach(x => {
            if (!hasChosen && airline[x].length) {
              hasChosen = true
              self.$store.commit('booking/setAirlinesLegData', {
                leg: leg,
                fields: {selectedCabin: x}
              })
              pass[leg] = true
            }
          })
        }
      }

      let otherLeg = leg === 'leg1' ? 'leg2' : 'leg1'
      let airline2 = self.airlines[otherLeg]
      if (self.isReturning && airline2.loading.indexOf(airline2.selectedCabin) === -1 && self.settings.customFlight) {
        pass[otherLeg] = airline2[airline2.selectedCabin].length > 0
        if (!pass[otherLeg]) {
          let cabins = self.apiType === 'API2' ? ['API2'] : [...self.booking.cabinList]
          let tmpLoading = [...airline2.loading]
          let doneCabin = cabins.filter(x => { return tmpLoading.indexOf(x) === -1 })
          let hasChosen = false
          doneCabin.forEach(x => {
            if (!hasChosen && airline2[x].length) {
              hasChosen = true
              self.$store.commit('booking/setAirlinesLegData', {
                leg: otherLeg,
                fields: {selectedCabin: x}
              })
              pass[otherLeg] = true
            }
          })
        }
      }
      if (!self.settings.customFlight) pass.leg2 = true

      // if any of the Ground quotation fails and flight is available switch to FLIGHT mode
      if (
        CONFIG.featureToggle.quoteReroute &&
        (self.groundQuoteError.pickup || self.groundQuoteError.dropoff) &&
        pass.leg1 && ((self.isReturning && pass.leg2) || !self.isReturning)
      ) {
        self.$store.commit('other/setOtherData', {widgetTab: 'flight'})
        self.proceedToService()
        return
      }

      if (
        (!pass.leg1 || (!pass.leg2 && self.isReturning)) &&
        !airline.loading.length && !airline2.loading.length
      ) {
        // if (
        //   CONFIG.featureToggle.quoteReroute &&
        //   (!self.groundQuoteError.pickup && !self.locations.isAirportPickup) &&
        //   (!self.groundQuoteError.dropoff && !self.locations.isAirportDropoff)
        // ) {
        //   self.$store.commit('other/setOtherData', {widgetTab: 'ground'})
        //   self.proceedToService(true)
        //   return
        // }
        let errorTier = Math.max(...[self.flightQuoteError.leg1, self.flightQuoteError.leg2])
        let errorMsg = 'No flights found. Please try again later.'
        if (errorTier === 2) errorMsg = 'Oops! Something went wrong. Please try again later.'
        if (errorTier === 1) errorMsg = 'Something went wrong. Please adjust your search and try again.'
        self.$store.commit('global/setAlertData', {show: true, message: errorMsg})
        self.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
        return
      }

      if (pass.leg1 && ((self.isReturning && pass.leg2) || !self.isReturning)) {
        self.proceedToService()
      }
    },
    proceedToService (directToGround = false) {
      if (directToGround) {
        this.$store.commit('reservation/setPickup', {leg: 'leg1', value: this.locations.pickup})
        this.$store.commit('reservation/setDropoff', {leg: 'leg1', value: this.locations.dropoff})
        this.$store.commit('reservation/setIsAirportPickup', {leg: 'leg1', value: false})
        this.$store.commit('reservation/setIsAirportDropoff', {leg: 'leg1', value: true})
        this.$store.commit('reservation/setIsAsap', { leg: 'leg1', value: false })
        let timeNow = moment()
        let div5 = timeNow.minutes() % 5
        timeNow = timeNow.subtract(div5, 'minutes')
        let date = this.filters.departure.date || moment().format('MM/DD/YYYY')
        this.$store.commit('reservation/setPickupDate', { leg: 'leg1', value: `${date} ${timeNow.format('hh:mmA')}` })
        this.$store.commit('serviceSelection/setForPickupDate', false)
        this.$store.commit('reservation/setIsRoundtrip', false)
        this.$emit('forceGround')
        // this.$router.push('service')
        return
      }

      let includedLandTranspo = []
      if (this.other.widgetTab === 'd2d' && (this.lastPickup !== this._pickup || this.lastDropoff !== this._dropoff)) {
        // Setup: Opt-in Ground Booking
        // includedLandTranspo = this.filters.departure.isReturning ? [0, 1, 2, 3] : [0, 1]
        if (!this.hideGround.pickup) includedLandTranspo.push(0)
        if (!this.hideGround.dropoff) includedLandTranspo.push(1)
        if (this.filters.departure.isReturning) {
          if (!this.hideGround.dropoff) includedLandTranspo.push(2)
          if (!this.hideGround.pickup) includedLandTranspo.push(3)
        }
      }
      this.$store.commit('booking/setOthersData', {includedLandTranspo: includedLandTranspo})

      document.body.classList.add('widget-full', 'd2d-mode')
      this.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
      this.$store.commit('booking/setOthersData', {servicesPage: 10})
      this.$router.push('d2dservice')
    },
    cabinLabel (x) {
      if (x === 'PremiumEconomy') return 'Premium Economy'
      return x
    },
    prepForceGround () {
      let self = this
      // self.$store.commit('other/setOtherData', {
      //   appLoader: true,
      //   appLoaderMsg: 'Don’t close now—your perfect ride is on the way! This only takes up to a minute.',
      //   useGroundLoadingMsg: true
      // })
      setTimeout(() => {
        self.$store.commit('global/setLoaderData', {show: false})
        self.$store.commit('other/setOtherData', {
          appLoader: false,
          appLoaderMsg: '',
          useGroundLoadingMsg: false
        })
        if (self.$refs.groundWidget) {
          self.$refs.groundWidget.forceGround()
        }
      }, 5000)
    },
    getThingsLocations () {
      let self = this
      self.$store.commit('things/setThingsLocationData', {loading: true})
      self.$sdk.get2(`${CONFIG.d2dAPI}/activities`, {}, r => {
        let list = []
        if (r.success) {
          list = r.data
          // self.$store.commit('things/setThingsLocationData', {list: r.data})
        }
        self.getThingsLocationsUS(list)
        // self.$store.commit('things/setThingsLocationData', {loading: false})
      })
    },
    getThingsLocationsUS (list) {
      let self = this
      self.$sdk.get2(`${CONFIG.d2dAPI}/activities/country/US`, {}, r => {
        let tmpList = list
        if (r.success) {
          tmpList = list.concat(r.data)
          // self.$store.commit('things/setThingsLocationData', {list: r.data})
        }
        if (tmpList.length) tmpList.sort((a, b) => a.origin - b.origin)
        tmpList = tmpList.filter((value, index, self) =>
          index === self.findIndex((t) => t.origin === value.origin)
        )
        self.$store.commit('things/setThingsLocationData', {list: tmpList})
        self.$store.commit('things/setThingsLocationData', {loading: false})
      })
    },
    activeThings () {
      this.$store.commit('other/setOtherData', {widgetTab: 'things'})
    },
    activeSightSeeing () {
      this.xTab = 'sight-seeing'
      this.$store.commit('other/setOtherData', {widgetTab: 'sight-seeing'})
      this.$forceUpdate()
    },
    activehotel () {
      this.xTab = 'hotel'
      this.$store.commit('other/setOtherData', {widgetTab: 'hotel'})
      this.$forceUpdate()
    },
    getLyftQuote (leg) {
      let self = this
      // self.$store.commit('reservation/setIsAsap', { leg: 'leg1', value: true })
      let pickupDate = moment(self.filters.departure.date, 'MM/DD/YYYY').format('YYYY-MM-DD')
      let pickup = self.locations.pickup
      let dropoff = self.locations.dropoff
      let quoteData = {
        leg: 'leg1',
        brandId: self.$store.state.brandId,
        pickupDate: pickupDate,
        pickup: { lat: pickup.lat, lng: pickup.lng },
        dropoff: { lat: dropoff.lat, lng: dropoff.lng },
        asap: true,
        order: 'priority'
      }
      quoteData.pickup = pickup
      quoteData.dropoff = dropoff
      ApiQuote.getQuote2(self, quoteData, r => {
        if (r.errors && r.errors.length || !r.lyft.length) {
          self.$store.commit('reservation/setMtechLegData', {
            leg: leg,
            fields: { services: {} }
          })
          self.$store.commit('reservation/setSelectedService', {
            leg: leg,
            value: ''
          })
          self.$store.commit('setCurrentIndex', 0)
          self.$store.commit('disablePreviousSteps', 3)
          let searchIndex = self.tmpSearchedLoc.findIndex(x => x.pickup.lat === quoteData.pickup.lat && x.pickup.lng === quoteData.pickup.lng && x.dropoff.lat === quoteData.dropoff.lat && x.dropoff.lng === quoteData.dropoff.lng)
          if (searchIndex > -1) self.tmpSearchedLoc.splice(searchIndex, 1)
          self.$store.commit('global/setAlertData', {
            show: true,
            message: self.$t('searchForm.serviceNA')
          })
          return
        }
        self.prepForceGround()
      })
    },
    changeTab (x) {
      this.xTab = x
      this.$store.commit('other/setOtherData', {widgetTab: 'd2d'})
      this.$forceUpdate()
    }
  },
  watch: {
    _pickup: function (value) {
      this.pickupText = value
    },
    _dropoff: function (value) {
      this.dropoffText = value
    },
    'logoutStore.success': function (val) {
      let self = this
      if (val) {
        self.forSomeoneElse = false
        self.$store.commit('global/setLoaderData', {show: true})
        self.$store.commit('global/setLogoutData', {success: false})
        self.$store.commit('user/setIsCorporate', false)
        setTimeout(function () {
          self.$store.commit('global/setLoaderData', {show: false})
        }, 500)
      }
    },
    xTab (x) {
      if (['rideFlight', 'flight', 'ride'].indexOf(x) > -1) {
        this.isReturning = x !== 'ride'
      }
    }
  },
  mounted () {
    console.log(7733)
    let self = this
    document.body.classList.remove('widget-full')
    let locations = this.locations
    if (this.other.widgetTab === 'flight' && this.locations.flight.pickup.title) locations = this.locations.flight
    if (locations.pickup.title) {
      this.pickup = locations.pickup.title
      this.pickupText = locations.pickup.title
      this.dropoff = locations.dropoff.title
      this.dropoffText = locations.dropoff.title
    }

    this.session = new WidgetSession(this)

    this.getThingsLocations()

    if ("geolocation" in navigator) {
      if (self._pickup) return
      navigator.geolocation.getCurrentPosition(pos => {
        // self.getFlightNearestAirport(pos.coords)
        let url = 'https://revgeocode.search.hereapi.com/v1/revgeocode?at={LAT}%2C{LNG}&apiKey={API_KEY}&lang=en-US&show=countryInfo'
        url = url.replace('{LAT}', pos.coords.latitude)
          .replace('{LNG}', pos.coords.longitude)
          .replace('{API_KEY}', CONFIG.hereApi.key)
        request.get({
          url: url,
          json: true
        }, function (err, res, body) {
          self.widgetErrorRemover = err
          self.widgetErrorRemover = res
          if (body && body.items && body.items.length) {
            let result = body.items[0]
            let finalResult = {
              title: result.title,
              address1: result.address.street || result.title,
              address2: result.address.houseNumber || result.address.district,
              city: result.address.city,
              state: result.address.state,
              zip: result.address.postalCode,
              country: result.address.countryCode,
              lat: result.position.lat,
              lng: result.position.lng
            }
            if (result.countryInfo && result.countryInfo.alpha2) {
              self.$store.commit('hotel/setData', {country: result.countryInfo.alpha2})
            }
            let isAirport = false
            if (body.categories) {
              body.categories.forEach(cat => {
                if (cat.name && cat.name.toLowerCase().indexOf('airport') > -1) isAirport = true
              })
            }
            finalResult.isAirport = isAirport

            let tmpObj = {pickup: ''}
            tmpObj.pickup = finalResult
            self.$store.commit('booking/setLocationsData', tmpObj)
            self.pickup = finalResult.title
            self.pickupText = finalResult.title
            self.$store.commit('booking/setOthersData', {defaultCountry: result.countryInfo ? result.countryInfo.alpha2 : finalResult.country})

            if (!localStorage.getItem('widgetCurrency')) {
              let currCountry = currencyCountry.find(x => x.countryCode === result.countryInfo.alpha2)
              if (currCountry) {
                if (['INR', 'CAD', 'EUR', 'GBP', 'JPY', 'CNY', 'AUD', 'AED', 'MXN', 'PHP'].indexOf(currCountry.currencyCode) > -1) {
                  self.currency = currCountry.currencyCode
                }
              }
            }

            if (result.countryInfo && result.countryInfo.alpha2) {
              self.$store.commit('other/setDefaultData', {
                country: result.countryInfo.alpha2,
                enabledLocation: true
              })
            }
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.search-page-tab{
  border-bottom:1px solid #CCD0E2;
  margin-bottom: 10px;

  .tab-opt{
    padding: 10px 25px;
    line-height: 1;
    font-size: 16px;
    letter-spacing: .5px;
    color: #B3B3B5;
    cursor: pointer;
    align-self: end;
    position: relative;

    &.active{
      border-bottom: 3px solid #CB952B;
      color: #CB952B;
    }
    .to-new{
      position: absolute;
      top: -12px;
      right: 0;
      font-size: 11px;
      line-height: 1;
      letter-spacing: 1px;
      background: #f53838;
      border: 1px solid #db0707;
      color: #fff;
      padding: 3px 4px;
      font-weight: 600;
      border-radius: 4px;
      box-shadow: 1px 1px 2px rgba(0, 0, 0, .3);
    }
  }
  .sp-account{
    gap: 15px;
    padding-right: 10px;
    letter-spacing: .4px;
    align-items: start;
  }
}
.welcome-txt{
  display: flex;
  gap: 15px;
  align-items: center;
  .user-x{
    text-decoration: underline;
  }
  .user-x, .mng-flights{
    color: #ff9c09;
    cursor: pointer;
  }
  .mng-flights{
    margin-left: 20px;
  }
}
.for-someone{
  font-size: 14px;
  line-height: 1;
  padding: 7px 0;
  text-align: left;
  display: block;
  width: 120px;
  white-space: nowrap;

  input{
    vertical-align: -2px;
    margin-right: 5px
  }
  span{
    letter-spacing: .5px;
  }
}

.search-page-fields{
  gap: 10px;
  padding: 10px;
}
.field-group{
  &.active{
    outline: 2px solid #ff9c09;
  }
  &.full-width{
    flex-grow: 1;
    max-width: 390px;

    &.add-limit{
      max-width: none;
    }
  }
}

.reverse-loc-box{
  border: 1px solid #CCD0E2;
  border-radius: 3px;
  line-height: 1;
  padding: 0;
  height: 40px;
  width: 40px;
  font-size:18px;
  cursor: pointer;
}

.min-cabin{
  max-width: 160px;
  border: 1px solid #bbb;
  border-radius: 1px;
  background: #fafafa;
  height: 40px;
  outline: none;
}

.search-page-notes{
  padding: 5px 10px 15px;
  font-size: 14px;
  color: #696767;
  text-align: left;

  .fa-check-square{
    color: #49c332;
    margin-right: 3px;
  }
}

@media only screen and (max-width: 641px) {
  .search-page-tab{
    flex-direction: column-reverse;
    gap: 20px;
    .sp-account{
      justify-content: center;
      flex-direction: column;
      align-items: center;
      gap: 5px;
    }
  }
  .tab-opt{
    width: 50%;
    text-align: center;
    white-space: nowrap;
  }

  .for-someone{
    text-align: center;
    margin-top: 10px;
    padding-bottom: 0;
  }

  .search-page-fields{
    flex-direction: column;
    align-items: normal;
    position: relative;
    padding: 20px;

    .reverse-loc-box{
      position: absolute;
      top: 40px;
      right: 25px;
      z-index: 2;
      background: #fff;
      box-shadow: 1px 1px 1px rgba(0, 0, 0, .1);

      i{
        transform: rotate(90deg);
      }
    }
  }

  .min-cabin{
    max-width: 100%;
    padding: 10px;
    background: #fafafa;
  }
  
  .search-page-notes{
    padding: 10px 20px;
  }
}
</style>


// WEBPACK FOOTER //
// index.vue?05849378